/**
 * Utility functions for creating and managing URL slugs on the frontend
 */

/**
 * Converts a string to a URL-friendly slug
 * @param text - The text to convert to a slug
 * @returns A URL-friendly slug
 */
export function createSlug(text: string): string {
  if (!text) return '';

  return text
    .toLowerCase()
    // Replace Bulgarian characters with Latin equivalents
    .replace(/а/g, 'a')
    .replace(/б/g, 'b')
    .replace(/в/g, 'v')
    .replace(/г/g, 'g')
    .replace(/д/g, 'd')
    .replace(/е/g, 'e')
    .replace(/ж/g, 'zh')
    .replace(/з/g, 'z')
    .replace(/и/g, 'i')
    .replace(/й/g, 'y')
    .replace(/к/g, 'k')
    .replace(/л/g, 'l')
    .replace(/м/g, 'm')
    .replace(/н/g, 'n')
    .replace(/о/g, 'o')
    .replace(/п/g, 'p')
    .replace(/р/g, 'r')
    .replace(/с/g, 's')
    .replace(/т/g, 't')
    .replace(/у/g, 'u')
    .replace(/ф/g, 'f')
    .replace(/х/g, 'h')
    .replace(/ц/g, 'ts')
    .replace(/ч/g, 'ch')
    .replace(/ш/g, 'sh')
    .replace(/щ/g, 'sht')
    .replace(/ъ/g, 'a')
    .replace(/ь/g, 'y')
    .replace(/ю/g, 'yu')
    .replace(/я/g, 'ya')
    // Remove special characters and replace spaces/underscores with hyphens
    .replace(/[^\w\s-]/g, '')
    .replace(/[\s_]+/g, '-')
    .replace(/^-+|-+$/g, '')
    // Ensure it doesn't exceed reasonable length
    .substring(0, 100);
}

/**
 * Validates if a string is a valid slug
 * @param slug - The slug to validate
 * @returns True if valid slug, false otherwise
 */
export function isValidSlug(slug: string): boolean {
  if (!slug) return false;
  
  // Check if slug contains only lowercase letters, numbers, and hyphens
  const slugPattern = /^[a-z0-9-]+$/;
  return slugPattern.test(slug) && !slug.startsWith('-') && !slug.endsWith('-');
}

/**
 * Checks if a string is a numeric ID
 * @param value - The value to check
 * @returns True if numeric ID, false otherwise
 */
export function isNumericId(value: string): boolean {
  return /^\d+$/.test(value);
}